// extracted by mini-css-extract-plugin
module.exports = {"relocate-page-title":"RelocateBoxFormPage_relocate-page-title__3XyAq"};